// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditStep_deleteButton__NTHkI"};